/**
 * @ngdoc controllers
 * @memberof mercury.modules.grossprofit
 * @name ReportsGrossProfitExpectedVsActualCtrl
 * @description A report with sales grouped by Item Category and report interval
 *
 * NOTE: This report while implemented has performance issues so is hidden
 *
 */
angular.module('mercury.modules.reports.grossprofit')
.controller('ReportsGrossProfitExpectedVsActualCtrl', ["title", "reporttime", "ReportGrossProfit", "$scope", function(title, reporttime, ReportGrossProfit, $scope) {
  title.set('Expected vs Actual');
  reporttime.setAllowedTypes(['week', 'month']);

  $scope.reportResults = [];
  $scope.categories = {};
  $scope.cogsGraphColumns = [
    {label: 'Period', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
    {label: 'Actual Gross Profit', type: 'number', key: 'actualGrossProfit', filter: 'currency'}
  ];

  $scope.loading = ReportGrossProfit.getExpectedVsActual(reporttime.start(), reporttime.end(), reporttime.interval());

  $scope.loading.then(function(result) {
    $scope.reportResults = result;
  });
}]);
